module.exports = __webpack_public_path__ + "static/media/DeviceVsPlan.d926bc0b.svg";